<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Начисленные зарплаты</h5>
      </div>
      <div class="card-body">
        <div class="flex">
          <div>
            <date-picker v-model="selectedMonth"
                         type="month"
                         @change="getSalaryCalculation"
                         placeholder="Выберите месяц"
                         :clearable="false"
            />
            <div class="form-group">
              <input type="checkbox" id="ch_1" @change="updateVisibility" v-model="showAll">
              <label class="pl-2 pointer" for="ch_1">Показать выплаты</label>
            </div>
          </div>
          <div class="ml-2" v-if="showSalaryProspects && !salaryProspects">
            <LoadingButton
              title="Просчитать прогноз"
              className="btn btn-outline-success btn-xs"
              :onClick="() => loadProspects()"
              :loading="prospectsLoading"
              :color="$constants.SUCCESS_COLOR"
            />
          </div>
        </div>

        <div v-if="loading">
          <pulse-loader :loading="true" :color="$constants.LOADING_COLOR" class="text-center"/>
        </div>
        <div v-else>
          <div>
            <table class="table table-sm table-hover table-striped salary_table mt-3">
              <thead>
              <tr>
                <th></th>
                <th>Сотрудник</th>
                <th v-if="showSalaryProspects && salaryProspects">Прогноз</th>
                <!--                <th>Зарплата</th>-->
                <th>Сдельная зарплата</th>
                <th>Общая сумма к выплате / Комментарий</th>
                <th></th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <template v-if="!showAll">
                <tr v-if="noVisible[user.id]" v-for="(user, index, i) in usersAccountDetails" :key="user.id"
                    v-bind:class="{tr_green:notAllowToPay[user.id]}">
                  <td>{{ i + 1 }}</td>
                  <td>
                    <p>{{ user.name }} ({{ user.id }})</p>
                    <p>
                    <span class="badge badge-info" v-for="(role, i) in user.roles">
                      {{ role.name_title }}
                    </span>
                    </p>
                  </td>
                  <td v-if="showSalaryProspects && salaryProspects">
                    <div v-if="salaryProspects[user.id]">
                      <p>заявки RUB: <strong>{{ Math.round(salaryProspects[user.id].orders_sum) }}</strong></p>
                      <p>заявки EUR: <strong>{{ Math.round(salaryProspects[user.id].orders_sum_eur) }}</strong></p>
                      <p>процент EUR: <strong>{{ Math.round(salaryProspects[user.id].calculated_rate) }}</strong></p>
                      <p>просчет: <strong>{{ Math.round(salaryProspects[user.id].prospect_eur) }}</strong></p>
                    </div>
                  </td>
                  <template v-if="salaryPayments[user.id]">
                    <td colspan="1">
                      <p>Заявки: <strong>{{ salaryPayments[user.id].data.orders_sum.toLocaleString('ru-RU') }}</strong>
                      </p>
                      <p>EUR: <strong>{{ salaryPayments[user.id].data.orders_sum_eur.toLocaleString('ru-RU') }}</strong>
                      </p>
                      <p>RATE: <strong>{{ salaryPayments[user.id].data.rate }}</strong></p>
                      <p>ЗП: <strong>{{ salaryPayments[user.id].data.base_salary.toLocaleString('ru-RU') }}</strong></p>
                    </td>
                    <td>
                      <div>
                        <p>Выплата: <strong>{{ salaryPayments[user.id].pay_date }}</strong></p>
                        <p>Период: {{ moment(salaryPayments[user.id].range_date_from) }} -
                          {{ moment(salaryPayments[user.id].range_date_to) }}</p>
                        <p>{{ $AllCurrencies[salaryPayments[user.id].currency_id].currency }}:
                          <strong>{{ salaryPayments[user.id].sum.toLocaleString('ru-RU') }}</strong></p>
                        <p>{{ salaryPayments[user.id].comment }}</p>
                      </div>
                      <template v-if="extraSalaryPayments[user.id]">
                        <p v-for="bonus in extraSalaryPayments[user.id]">
                          {{ types[bonus.type_id] }}: {{ $AllCurrencies[bonus.currency_id].currency }}
                          <strong>{{ bonus.sum.toLocaleString('ru-RU') }}</strong> ({{ bonus.comment }})
                          <span class="text-muted">{{ printDate(bonus.created_at) }}</span>
                        </p>
                      </template>
                    </td>
                    <td>
                      {{
                        $AllDivisions[salaryData[user.id].salary_data.division_id] && $AllDivisions[salaryData[user.id].salary_data.division_id].user.short_name || 'Администрация'
                      }}
                    </td>
                  </template>
                  <template v-else>
                    <td v-if="false">
                      {{ salaryData[user.id].salary_data.base_salary }}
                      {{
                        $AllCurrencies[salaryData[user.id].salary_data.base_currency] && $AllCurrencies[salaryData[user.id].salary_data.base_currency].currency || 'не найдена валюта ' + salaryData[user.id].salary_data.base_currency
                      }}
                    </td>
                    <td>
                      <template v-if="salaryData[user.id].salary_data.rate">
                        <div class="small_font">
                          <p>заявки RUB:
                            {{ ordersData[user.id] && ordersData[user.id].orders_sum.toLocaleString('ru-RU') || 0 }}</p>
                          <p>EUR: {{
                              ordersData[user.id] && ordersData[user.id].orders_sum_eur.toLocaleString('ru-RU')
                            }}</p>
                          <p>RATE: {{ salaryData[user.id].salary_data.rate }}</p>
                        </div>
                        <template v-if="ordersData[user.id]">
                          <div class="small_font">
                            <!--                          <p>CALCULATED RATE: {{ Math.round((ordersData[user.id].orders_sum_eur * salaryData[user.id].salary_data.rate)).toLocaleString('ru-RU') }} EUR</p>-->
                            <p>CALCULATED RATE: {{ ordersData[user.id].calculated_rate.toLocaleString('ru-RU') }}
                              EUR</p>
                          </div>
                          <p>Rate %: {{
                              !currencyRates[usersPayCurrency[user.id]] ? 'no currency rate' : Math.round((ordersData[user.id].calculated_rate / currencyRates[usersPayCurrency[user.id]].rate)).toLocaleString('ru-RU')
                            }} {{
                              !currencyRates[usersPayCurrency[user.id]] ? 'no currency rate' : currencyRates[usersPayCurrency[user.id]].currency
                            }}</p>
                        </template>
                      </template>
                      <p>Fix Salary: {{ salaryData[user.id].salary_data.base_salary }} {{
                          (currencyRates[salaryData[user.id].salary_data.base_currency] && currencyRates[salaryData[user.id].salary_data.base_currency].currency) || 'не найден курс ' + salaryData[user.id].salary_data.base_currency
                        }}
                        <template v-if="salaryData[user.id].salary_data.base_currency !== usersPayCurrency[user.id]">
                          ({{
                            !currencyRates[usersPayCurrency[user.id]] ? 'no currency rate' : Math.round(salaryData[user.id].salary_data.base_salary * currencyRates[salaryData[user.id].salary_data.base_currency].rate / currencyRates[usersPayCurrency[user.id]].rate)
                          }}
                          {{
                            !currencyRates[usersPayCurrency[user.id]] ? 'no currency rate' : currencyRates[usersPayCurrency[user.id]].currency
                          }})
                        </template>
                      </p>
                    </td>
                    <td>
                      <div class="flex">
                        <div class="input-group" v-if="!notAllowToPay[user.id]">
                          <input type="number" v-model="usersPayData[user.id].sum" class="form-control"
                                 placeholder="Сумма выплаты" aria-describedby="basic-addon2">
                          <div class="input-group-append">
                            <select @change="updateSum(user.id)" v-model="usersPayData[user.id].currency"
                                    class="form-control">
                              <option v-for="currency in allowedCurrencies" :key="currency.id" :value="currency.id">
                                {{ currency.currency }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <input type="text" v-model="usersPayData[user.id].comment" class="form-control">
                      </div>
                      <template v-if="extraSalaryPayments[user.id]">
                        <p v-for="bonus in extraSalaryPayments[user.id]">
                          {{ types[bonus.type_id] }}: {{ $AllCurrencies[bonus.currency_id].currency }}
                          <strong>{{ bonus.sum.toLocaleString('ru-RU') }}</strong> ({{ bonus.comment }})
                          <span class="text-muted">{{ printDate(bonus.created_at) }}</span>
                        </p>
                      </template>
                      <template v-if="!usersPayData[user.id].bonus">
                        <button @click="addBonus(user.id)" class="btn btn-outline-info btn-xs">Еще выплата</button>
                      </template>
                      <template v-else>
                        <div class="flex">
                          <div class="input-group">
                            <input type="number" v-model="usersPayData[user.id].bonus.sum" class="form-control"
                                   placeholder="Комментарий">
                            <div class="input-group-append">
                              <select v-model="usersPayData[user.id].bonus.currency" class="form-control">
                                <option v-for="currency in usersPayData[user.id].bonus.currencies" :key="currency"
                                        :value="currency">{{ $AllCurrencies[currency].currency }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <input type="text" v-model="usersPayData[user.id].bonus.comment" class="form-control">
                        </div>
                      </template>
                    </td>
                    <td>
                      <p>
                        {{
                          $AllDivisions[salaryData[user.id].salary_data.division_id] && $AllDivisions[salaryData[user.id].salary_data.division_id].user.short_name || 'Администрация'
                        }}
                      </p>
                      <LoadingButton
                        title="Выплатить"
                        className="btn btn-outline-success btn-xs"
                        :onClick="() => makePayment(user.id)"
                        :loading="loadingBtns[user.id]"
                        :color="$constants.SUCCESS_COLOR"
                      />
                    </td>
                  </template>
                  <td>
                    <input v-if="!notAllowToPay[user.id]" type="checkbox" v-model="selectedUsers[user.id]">
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="(payment, userId, i) in salaryPayments">
                  <td>{{ i + 1 }}</td>
                  <td>
                    <p>{{ payment.user.name }} ({{ payment.user.id }})</p>
                    <p>
                    <span class="badge badge-info" v-for="(role, i) in payment.user.roles">
                      {{ role.name_title }}
                    </span>
                    </p>
                  </td>
                  <td colspan="1">
                    <p>Заявки: <strong>{{ payment.data.orders_sum.toLocaleString('ru-RU') }}</strong></p>
                    <p>EUR: <strong>{{ payment.data.orders_sum_eur.toLocaleString('ru-RU') }}</strong></p>
                    <p>RATE: <strong>{{ payment.data.rate }}</strong></p>
                    <p>ЗП: <strong>{{ payment.data.base_salary.toLocaleString('ru-RU') }}</strong></p>
                  </td>
                  <td>
                    <div>
                      <p>Выплата: <strong>{{ payment.pay_date }}</strong></p>
                      <p>Период: {{ moment(payment.range_date_from) }} - {{ moment(payment.range_date_to) }}</p>
                      <p>{{ $AllCurrencies[payment.currency_id].currency }}:
                        <strong>{{ payment.sum.toLocaleString('ru-RU') }}</strong></p>
                      <p>{{ payment.comment }}</p>
                    </div>
                    <template v-if="extraSalaryPayments[userId]">
                      <p v-for="bonus in extraSalaryPayments[userId]">
                        {{ types[bonus.type_id] }}: {{ $AllCurrencies[bonus.currency_id].currency }}
                        <strong>{{ bonus.sum.toLocaleString('ru-RU') }}</strong> ({{ bonus.comment }})
                        <span class="text-muted">{{ printDate(bonus.created_at) }}</span>
                      </p>
                    </template>
                  </td>
                  <td>
                    {{
                      $AllDivisions[payment.division_id] && $AllDivisions[payment.division_id].user.short_name || 'Администрация'
                    }}
                  </td>
                  <td></td>
                </tr>
              </template>
              </tbody>
            </table>
            <div class="text-right">
              <LoadingButton
                title="Выплатить выбранным сотрудникам"
                className="btn btn-outline-success btn-xs"
                :onClick="() => makePayment()"
                :loading="selectedLoading"
                :color="$constants.SUCCESS_COLOR"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton"
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/ru";
import moment from "moment";

export default {
  components: {
    LoadingButton,
    DatePicker,
  },
  data() {
    return {
      noVisible: {},
      prospectsLoading: false,
      showSalaryProspects: false,
      salaryProspects: null,
      showAll: false,
      selectedMonth: moment().subtract(1, 'month').set('date', 1).toDate(),
      selectedLoading: false,
      selectedUsers: {},
      salaryPayments: {},
      extraSalaryPayments: {},
      notAllowToPay: {},
      loading: false,
      usersAccountDetails: null,
      usersPayData: {},
      usersPayCurrency: {},
      salaryData: null,
      ordersData: null,
      allowedCurrencies: {},
      loadingBtns: {},
      currencyRates: {},
      salaryRange: {},
      types: {
        2: 'Бонус',
        3: 'Аванс',
      }
    }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters['platform/currencies']
    },
    $AllDivisions() {
      return this.$store.getters["platform/divisions"];
    },
  },
  mounted() {
    this.allowedCurrencies = Object.keys(this.$AllCurrencies).reduce((acc, c) => {
      if ([34, 28, 29, 33].includes(+c)) {
        acc[c] = {...this.$AllCurrencies[c]};
      }
      return acc;
    }, {});
    this.getSalaryCalculation();
  },
  methods: {
    async loadProspects() {
      this.prospectsLoading = true;
      const {data} = await api.index('/users/salaryp');
      if (data.success) {
        this.salaryProspects = data.salaryData;
      }
      this.prospectsLoading = false;
    },
    addBonus(uId) {
      let currencies;
      if (this.usersPayData[uId].currency === 29) {
        currencies = [34];
      } else {
        currencies = [29];
      }
      this.$set(this.usersPayData[uId], 'bonus', {
        currency: currencies[0],
        sum: 0,
        comment: this.usersPayData[uId].comment,
        currencies: currencies
      });
    },
    async makePayment(userId = null) {
      if (this.selectedLoading) return;
      let selectedUsers = [];
      if (userId) {
        this.loadingBtns[userId] = true;
      } else {
        selectedUsers = Object.keys(this.selectedUsers).filter((s) => this.selectedUsers[s]);
        if (!selectedUsers || !selectedUsers.length) {
          toastr['warning']('Выберите сотрудников');
          return;
        }
        this.selectedLoading = true;
      }

      let sendData = {};

      if (userId) {
        sendData = {
          userId: userId,
          month: this.selectedMonth,
          ordersData: this.ordersData[userId],
          salaryRange: this.salaryRange,
          salaryData: this.salaryData[userId].salary_data,
          payData: this.usersPayData[userId]
        };
      } else {
        sendData.multiPayment = true;
        sendData.month = this.selectedMonth;
        sendData.usersData = [];
        selectedUsers.forEach((id) => {
          sendData.usersData.push({
            userId: id,
            ordersData: this.ordersData[id],
            salaryRange: this.salaryRange,
            salaryData: this.salaryData[id].salary_data,
            payData: this.usersPayData[id]
          })
        });
      }

      const {data} = await api.post('users/salary', sendData)
      if (data.success) {
        toastr['success']('Сохранено');
        if (userId) {
          this.notAllowToPay = {...this.notAllowToPay, [userId]: true};
          this.salaryPayments[userId] = data.payment;
        } else {
          await this.getSalaryCalculation();
        }
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      if (userId) {
        this.loadingBtns[userId] = false;
      }
      this.selectedLoading = false;
    },
    updateSum(userId = null) {
      let usersSalaryData = [];
      if (!userId) {
        usersSalaryData = Object.keys(this.salaryData);
      } else {
        usersSalaryData.push(userId);
      }

      usersSalaryData.forEach((uId) => {
        const baseSalary = Math.round((this.salaryData[uId].salary_data.base_salary * this.currencyRates[this.salaryData[uId].salary_data.base_currency].rate) / this.currencyRates[this.usersPayData[uId].currency].rate);
        let sum = baseSalary;
        if (this.salaryData[uId].salary_data && this.salaryData[uId].salary_data.rate && this.ordersData[uId]) {
          const baseRateSum = this.salaryData[uId].salary_data.rate ? Math.round(this.ordersData[uId].calculated_rate / this.currencyRates[this.usersPayData[uId].currency].rate) : 0;
          sum = baseSalary + baseRateSum;
        }
        this.usersPayData[uId].sum = sum;
      });
    },
    updateVisibility() {
      if (this.showAll) {
        this.noVisible = _.mapValues(this.usersAccountDetails, () => true);
      } else {
        this.noVisible = Object.keys(this.usersAccountDetails).reduce((acc, uId) => {
          acc[uId] = !!!this.notAllowToPay[uId];
          return acc;
        }, {});
      }
    },
    async getSalaryCalculation() {
      this.loading = true;
      const {data} = await api.index('users/salary?date=' + moment(this.selectedMonth).format('YYYY-MM-DD'));
      if (data.success) {
        this.fillUserPayData(data);
        this.salaryRange = data.salaryRange;
        this.currencyRates = data.currencyRates;
        this.usersAccountDetails = data.usersAccountDetails;
        this.salaryData = data.salaryData;
        this.ordersData = data.ordersData;
        const notAllowToPay = {};
        const selectedUsers = {};
        const selectedMonth = moment(this.selectedMonth).format('YYYY-MM-DD');
        const extraPayment = {};
        this.salaryPayments = data.salaryPayments.reduce((acc, p) => {
          if (p.range_date_from === selectedMonth) {
            if (p.type_id === 1) {
              notAllowToPay[p.user_id] = true;
              acc[p.user_id] = {...p};
              selectedUsers[p.user_id] = false;
            } else {
              if (!extraPayment[p.user_id]) {
                extraPayment[p.user_id] = [];
              }
              extraPayment[p.user_id].push({...p});
            }
          }
          return acc;
        }, {});
        this.extraSalaryPayments = extraPayment;
        this.selectedUsers = selectedUsers;
        this.notAllowToPay = {...notAllowToPay};
        const usersPayCurrency = {};
        Object.keys(data.salaryData).forEach((uId) => {
          usersPayCurrency[uId] = data.salaryData[uId].salary_data.pay_currency_id;
        })
        this.usersPayCurrency = usersPayCurrency;
        this.showSalaryProspects = false;
        if (moment(this.selectedMonth).format('YYYY-MM-01') === moment().format('YYYY-MM-01')) {
          this.showSalaryProspects = true;
        }
        this.updateVisibility();
        this.updateSum();
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.loading = false;
    },
    fillUserPayData(data) {
      let newPayData = {};
      Object.keys(data.salaryData).forEach((uId) => {
        newPayData[uId] = {
          // currency: data.salaryData[uId] && data.salaryData[uId].salary_data && data.salaryData[uId].salary_data.base_currency || 28,
          currency: data.salaryData[uId] && data.salaryData[uId].salary_data && data.salaryData[uId].salary_data.pay_currency_id || 28,
          comment: 'Зарплата ' + (data.usersAccountDetails[uId] && data.usersAccountDetails[uId].name || 'имя не найдено'),
          sum: 0
        };
        this.loadingBtns[uId] = false;
      });
      this.loadingBtns = {...this.loadingBtns};
      this.usersPayData = newPayData;
    },
    moment: function (date, format = "DD.MM.YYYY", object = false) {
      if (!date) return;
      const objectDate = moment(date);
      if (object) return objectDate;
      return objectDate.format(format);
    },
  }
}
</script>

<style scoped>
.small_font {
  font-size: 11px;
}

.tr_green {
  background-color: #daffda !important;
}

table p {
  margin-bottom: 1px;
}
</style>
